export default __webpack_public_path__ + "static/media/copy-solid.26b40cfa.svg";